import { FileRequestPlaceholderWithRelations } from 'bff';
import { format } from 'date-fns';
import React from 'react';
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
  Label,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  cn,
} from 'ui';
import { FileList, FileListItem, FileListLabel } from './File';
import { getInitialsFromUser } from 'utils';

const Container = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <div className={cn('mt-4 space-y-6', className)}>{children}</div>;
};

export const FileListPlaceholder = ({
  placeholder,
  active = true,
}: {
  placeholder: FileRequestPlaceholderWithRelations;
  active?: boolean;
}) => {
  return (
    <div
      className={cn({
        'cursor-default opacity-50 line-through': !active,
      })}
    >
      <Label>{placeholder.tag.name}</Label>
      <FileList>
        {placeholder.files.map(
          (
            { mimetype, original_name, url, uploaded_by, created_at },
            index,
          ) => {
            return (
              <FileListItem className='relative w-full' key={index}>
                <a className='hover:underline' target='_blank' href={url}>
                  <FileListLabel mimetype={mimetype}>
                    {original_name}
                  </FileListLabel>
                </a>
                {uploaded_by && (
                  <div className='absolute right-0 -bottom-2'>
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger>
                          <Avatar size='xs'>
                            <AvatarImage src={uploaded_by!.profile_photo!} />
                            <AvatarFallback className='text-xs'>
                              {getInitialsFromUser(uploaded_by)}
                            </AvatarFallback>
                          </Avatar>
                        </TooltipTrigger>
                        <TooltipContent className='text-xs'>
                          subido el {format(new Date(created_at), 'Pp')}
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                  </div>
                )}
              </FileListItem>
            );
          },
        )}
      </FileList>
    </div>
  );
};

FileListPlaceholder.Container = Container;
